<script lang="ts">
	import HighlightedText from '$lib/components/filters/HighlightedText.svelte';
	import { getContext } from 'svelte';

	import type FilterProvider from './store.svelte';
	import type { FilterValue } from './store.svelte';

	const {
		name,
		value,
		searchQuery,
		isShowingMore,
		onchange = () => {},
	}: {
		name: string;
		value: FilterValue;
		searchQuery: string;
		isShowingMore: boolean;
		onchange?: CallableFunction;
	} = $props();

	const filterProvider = getContext<FilterProvider>('filter');
</script>

<!-- TMP workaround with onchange+checked instead of bind:group. As bind:group doesn't work with deep reactive state -->
<label
	class="flex w-full cursor-pointer items-center justify-between bg-white px-2 py-1 transition-colors hover:bg-neutral-100 has-checked:bg-neutral-200 has-checked:hover:bg-neutral-300"
>
	<input
		type="checkbox"
		class="accent-black"
		value={value.value}
		checked={filterProvider.isChecked(name, value.value)}
		onchange={() => {
			filterProvider.toggle(name, value.value);
			onchange?.();
		}}
	/>
	<span
		class={[
			'flex w-full justify-between px-2 select-none',
			{
				'font-semibold': value.is_main && isShowingMore,
			},
		]}
	>
		<HighlightedText text={filterProvider.displayValue(value.value)} toHighlight={searchQuery} />
		<span>
			{value.count}
		</span>
	</span>
</label>
